<template>
  <div>
    <h1>Bedankt voor het invullen van de vragenlijst.</h1>
    <v-btn large href="https://vigogroep.nl" class="mt-4" color="primary">Sluiten</v-btn>
  </div>
</template>

<script>
export default {};
</script>